import { authorizedFetch } from './utils';
import appConfig from '../config/appConfig';

const baseApi = appConfig.api.baseUrl;

/**
 * Redeem AppSumo coupon code
 * @param {string} couponCode - The AppSumo coupon code
 * @returns {Promise<Object>} Redemption result
 */
export async function redeemAppSumoCoupon(couponCode) {
  try {
    // First, validate the coupon with AppSumo API
    const appSumoResponse = await validateWithAppSumo(couponCode);
    
    // Then post the result to our server
    const response = await authorizedFetch(`${baseApi}/api/Redeem`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        couponCode,
        appSumoResponse
      }),
    });

    if (!response.ok) {
      let errorMessage = `API error: ${response.status}`;
      try {
        const errorData = await response.text();
        if (errorData) {
          try {
            const jsonError = JSON.parse(errorData);
            errorMessage = jsonError.message || jsonError.error || jsonError.title || jsonError;
          } catch {
            errorMessage = errorData;
          }
        }
      } catch {
        // Fallback to generic message
      }
      
      const error = new Error(errorMessage);
      error.status = response.status;
      error.response = { status: response.status };
      throw error;
    }

    return response.json();
  } catch (error) {
    console.error('Error redeeming coupon:', error);
    throw error;
  }
}

/**
 * Validate coupon code with AppSumo API
 * @param {string} couponCode - The coupon code to validate
 * @returns {Promise<Object>} AppSumo API response
 */
async function validateWithAppSumo(couponCode) {
  try {
    // AppSumo API endpoint for coupon validation
    const appSumoApiUrl = 'https://appsumo.com/api/v1/coupons/validate';
    
    const response = await fetch(appSumoApiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Add any required AppSumo API headers here
        // 'Authorization': 'Bearer YOUR_APPSUMO_API_KEY',
      },
      body: JSON.stringify({
        coupon_code: couponCode,
        // Add any other required AppSumo API parameters
      }),
    });

    if (!response.ok) {
      throw new Error(`AppSumo API error: ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error('Error validating with AppSumo:', error);
    throw error;
  }
}

export { baseApi };
